import { message } from "antd";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import uri from "../../constants/uri";

const playNotice = (noticeId) => async () => {
	if (noticeId) {
		try {
			const response = await client.get(`${uri}/notification_start`, {
				headers: authHeader(),
				params: { notificationId: noticeId },
			});
			message.success("Оповещение запущено!");
		} catch (error) {
			console.error(error);
			message.error("Не получилось запустить оповещение");
		}
	}
};
export default playNotice;
